'use client'

import { TableSize } from '@/components/common/table-size'
import { Tabs } from '@/components/ui/tabs'
import { useMemo, useState } from 'react'
import { SIZE_DATA } from '../../../../../lib/constants/size'
import { BodyInfo } from './body-info'
import { CalculateSize } from './caculate-size'
import { GuideLegging } from './guide-legging'
import { ProductSizeInfo } from './product-size-info'

type Props = {
  sizeChart: string
  isOnlyTable?: boolean
}

export const SizeTableContent = ({ sizeChart, isOnlyTable }: Props) => {
  const sizeData = SIZE_DATA[sizeChart]
  const [sizeTab, setSizeTab] = useState('product-info')

  const isBraOrLegging = useMemo(
    () => ['BRA', 'LEGGING'].includes(sizeChart),
    [sizeChart]
  )

  const options = useMemo(() => {
    const tabs = [
      {
        label: 'Thông số sản phẩm',
        value: 'product-info',
        content: <ProductSizeInfo />,
      },
    ]

    // Chỉ thêm tab thông số cơ thể nếu không phải BRA hoặc LEGGING
    if (!isBraOrLegging) {
      tabs.push({
        label: 'Thông số cơ thể',
        value: 'body-info',
        content: <BodyInfo />,
      })
    }

    return tabs
  }, [isBraOrLegging])

  return (
    <div className='mt-2 pb-15'>
      {!isOnlyTable && <CalculateSize sizeChart={sizeChart} />}

      {sizeData && (
        <>
          <TableSize
            rows={sizeData.rows}
            columns={sizeData.columns}
            matrix={sizeData.matrix}
            title='Thông số cơ thể'
            headerTitle={sizeData.headerTitle}
            leftTitle={sizeData.leftTitle}
            className='mt-8'
            suffixCol='CM'
          />
        </>
      )}
      <div className='my-8 rounded bg-neutral-200 px-4 py-3 font-sans text-sm leading-4.5 text-neutral-800/90'>
        <p className='font-bold'>Lưu ý khi chọn size:</p>
        <ul className='list-disc pl-4'>
          <li>
            Lý tưởng cho phụ nữ có{' '}
            <strong>chiều cao từ 155cm đến 175cm.</strong>
          </li>
          <li>Thông số được tính bằng centimet (cm).</li>
          <li>
            Size gợi ý mang tính tham khảo, vui lòng xem bảng{' '}
            <strong>thông số</strong> để chọn size phù hợp.
          </li>
        </ul>
      </div>
      <div>
        {options.length > 1 ? (
          <Tabs
            options={options}
            onChange={(value) => setSizeTab(value)}
            defaultValue={sizeTab}
            className='h-fit border-b border-b-neutral-200 pb-0'
            triggerClassName='flex-1 border-b-[3px] font-semibold font-sans text-sm leading-4.5 px-4'
          />
        ) : (
          <ProductSizeInfo sizeChart={sizeChart} />
        )}

        {sizeChart === 'LEGGING' && <GuideLegging />}
      </div>
    </div>
  )
}
